topApsByPeriod(){
     
      let aps = {
        avarage: [],
        nome: [],
      };

      let apsId = [];
      let totalAvarage = [];
      let apsName = [];
      let apsNameComplete;
      let totalAps = [];
      let topApsInfoUnordered = [];
      let topApsInfo;

      if (this.topAps.length > 1) {
        this.topAps.sort((a, b) => {
          if (!a.periodAverage) return 1;
          if (!b.periodAverage) return 1;
          if (a.periodAverage > b.periodAverage) return -1;
          if (a.periodAverage < b.periodAverage) return 1;
          return 0;
        });
      
        totalAps = this.topAps.splice(0, 5);

        totalAps.forEach((element, index) => {
          totalAvarage[index] = element.periodAverage;
          apsId[index] = element.ap_id;
        });

  
        topApsInfoUnordered = this.radios.filter((element) =>
          apsId.includes(element.ip)
        );

        topApsInfo = apsId.map((el) => {
            
        for (let i = 0; i < topApsInfoUnordered.length; i++) {
          if (topApsInfoUnordered[i].ip === el)
            return topApsInfoUnordered[i];
          }
        });


        topApsInfo.forEach((element, index) => {
          apsNameComplete = element.name.split("_");
          apsName[index] = apsNameComplete[1];
        });

        return aps = {
          avarage: totalAvarage.map((el) => {
          return `${(el * 100).toFixed(2)}%`;
          }),
          name: apsName.map((el, index) => {
          return `${index + 1} - ${el}`;
          }),
        }
        
      }
      else{
        return aps = {
          avarage: [],
          name: "NÃO HÁ DADOS PARA ESSA DATA"
        }
      }
        
    },
<script>
import { HorizontalBar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

Chart.defaults.scale.gridLines.display = false;

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: ["chartData", "titulo"],
  data() {
    return {
      options: {
        title: {
          display: true,
          text: this.titulo
        },
        responsive: true,
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: false,
                fontFamily: "'Open Sans Bold', sans-serif",
                fontSize: 9
              },
              scaleLabel: {
                display: false
              },
              gridLines: { display: false },
              stacked: true
            }
          ],
          yAxes: [
            {
              display: true,

              stacked: true
            }
          ]
        },
        hover: {
          mode: "nearest",
          intersect: true
        },
        onClick: function clickHandler(evt) {
          var firstPoint = this.getElementAtEvent(evt)[0];

          if (firstPoint) {
            var label = this.data.labels[firstPoint._index];
            var value = this.data.datasets[firstPoint._datasetIndex].data[
              firstPoint._index
            ];

            evt.stopPropagation();

            document.dispatchEvent(
              new CustomEvent("openDay", {
                detail: label
              })
            );
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: () => {
      try {
        this.renderChart(this.chartData, this.options);
      } catch (error) {
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/charts/HorizontalBar.vue